// Generated by ReScript, PLEASE EDIT WITH CARE

import * as DragPreview46BindJs from "./DragPreview46.bind.js";

var make = DragPreview46BindJs.Preview;

export {
  make ,
  
}
/* make Not a pure module */
